/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_DescriptionInputs */



/**
* | output |
* | --- |
* | "Import media from various sources and configure media settings" |
*
* @param {Media_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_description = /** @type {((inputs?: Media_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer des medias depuis diverses sources et configurer les parametres du media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importieren Sie Medien aus verschiedenen Quellen und konfigurieren Sie die Medieneinstellungen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa contenuti multimediali da varie fonti e configura le impostazioni multimediali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортируйте медиафайлы из различных источников и настраивайте параметры воспроизведения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar medios desde varias fuentes y configurar ajustes de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从各种来源导入媒体并配置媒体设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("さまざまなソースからメディアをインポートし、メディア設定を構成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विभिन्न स्रोतों से मीडिया आयात करें और मीडिया सेटिंग्स कॉन्फ़िगर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importe conteúdo de diversas fontes e configure as definições de mídia.")
	return /** @type {LocalizedString} */ ("Import media from various sources and configure media settings")
});